import script from "./ScoreCircle.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreCircle.vue?vue&type=script&setup=true&lang=js"

import "./ScoreCircle.vue?vue&type=style&index=0&id=23b22bce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23b22bce"]])

export default __exports__